import { Button } from 'components/Button';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useRepresentative } from 'hooks/useRepresentative';
import { useHistory } from 'react-router-dom';
import { IRepresentant } from 'types/Representant';
import {
  maskCep,
  maskCNPJ,
  maskCpf,
  maskPhone,
  maskResidentialPhone,
} from 'util/masks';

import { Box, Divider, Grid, Stack, Typography } from '@mui/material';

type IRepresentativeData = {
  representant?: IRepresentant | null;
};

type IItemIRepresentative = {
  title: string;
};

const ItemRepresentative: React.FC<IItemIRepresentative> = ({
  title,
  children,
}) => {
  return (
    <Grid item xs={12} md={3} sm={6} mb={2}>
      <Typography color="GrayText">{title}</Typography>
      <Stack direction="row" spacing={1} mt={1}>
        <Typography color="#40444D" sx={{ wordBreak: 'break-all' }}>
          {children ? children : '-'}
        </Typography>
      </Stack>
    </Grid>
  );
};

export const RepresentativeData: React.FC<IRepresentativeData> = ({
  representant,
}) => {
  const { push } = useHistory();
  const { loading } = useRepresentative();

  if (!representant) {
    return null;
  }

  const handleEdit = () => {
    push(`/admin/dashboard/representative/edit/${representant._id}`);
  };

  return (
    <PaperCardTemplate loading={loading}>
      <Box p={2}>
        <Grid container alignItems="flex-start">
          <Grid item xs={2}>
            <Typography fontWeight={700} fontSize={18}>
              DADOS CADASTRAIS
            </Typography>
          </Grid>

          <Grid item xs={10}>
            <Divider sx={{ mt: 2, mb: 2, ml: 1 }} />
          </Grid>
        </Grid>

        <Grid container spacing={2} p={2}>
          <ItemRepresentative title="Razão Social">
            {representant?.socialReason}
          </ItemRepresentative>

          <ItemRepresentative title="Nome Fantasia">
            {representant?.tradingName}
          </ItemRepresentative>

          <ItemRepresentative title="Número do CNPJ">
            {maskCNPJ(representant?.cnpj)}
          </ItemRepresentative>

          <ItemRepresentative title="Número do CPF">
            {maskCpf(representant?.cpf)}
          </ItemRepresentative>

          <ItemRepresentative title="Nome">
            {representant?.name}
          </ItemRepresentative>

          <ItemRepresentative title="Telefone Fixo">
            {maskResidentialPhone(representant?.phone || '')}
          </ItemRepresentative>

          <ItemRepresentative title="Telefone Celular">
            {maskPhone(representant?.mobilePhone || '')}
          </ItemRepresentative>

          <ItemRepresentative title="CEP">
            {maskCep(representant?.address?.cep)}
          </ItemRepresentative>

          <ItemRepresentative title="Logradouro">
            {representant?.address?.street}
          </ItemRepresentative>

          <ItemRepresentative title="Número">
            {representant?.address?.number}
          </ItemRepresentative>

          <ItemRepresentative title="Bairro">
            {representant?.address?.neighborhood}
          </ItemRepresentative>

          <ItemRepresentative title="Cidade">
            {representant?.address?.city}
          </ItemRepresentative>

          <ItemRepresentative title="Estado">
            {representant?.address?.state}
          </ItemRepresentative>

          <ItemRepresentative title="Complemento">
            {representant?.address?.complement}
          </ItemRepresentative>

          <ItemRepresentative title="E-mail">
            {representant?.email}
          </ItemRepresentative>

          <ItemRepresentative title="Estado de Atuação">
            {representant?.workingState?.join(', ')}
          </ItemRepresentative>

          <ItemRepresentative title="Site">
            {representant?.site}
          </ItemRepresentative>

          <ItemRepresentative title="Instagram">
            {representant?.instagram}
          </ItemRepresentative>

          <ItemRepresentative title="Facebook">
            {representant?.facebook}
          </ItemRepresentative>
          <Grid item xs={12} md={3} sm={6} alignSelf="self-end">
            <Stack mb={2} direction="row" justifyContent="stretch">
              <Button sx={{ paddingX: 4 }} onClick={handleEdit}>
                editar
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </PaperCardTemplate>
  );
};

